<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Cover: Retirement 101, by Michele Cagan, CPA" class="imagefp" epub:type="cover" role="doc-cover" src="e9781507212257/images/9781507212257.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?cffa2fb4